

export const CALENDAR_COLORS = {
  allAvaiableColor: "#b3f9bd",
  fullDayColor: "#f85c5cad",
  someAvaiableColor: "#ded9768a",
};
